var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointMart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9751_26971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2002 8.77002H22.2002V17.5H8.2002L5.2002 8.77002Z",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 8.77L23.2002 4.5H26.2002",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6302 25.36C11.42 25.36 12.0602 24.7198 12.0602 23.93C12.0602 23.1402 11.42 22.5 10.6302 22.5C9.84043 22.5 9.2002 23.1402 9.2002 23.93C9.2002 24.7198 9.84043 25.36 10.6302 25.36Z",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7698 25.36C23.5596 25.36 24.1998 24.7198 24.1998 23.93C24.1998 23.1402 23.5596 22.5 22.7698 22.5C21.9801 22.5 21.3398 23.1402 21.3398 23.93C21.3398 24.7198 21.9801 25.36 22.7698 25.36Z",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 17.5L24.2002 20.5H8.2002",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2002 11.5V14.5",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7002 11.5V14.5",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 11.5V14.5",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9751_26971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 21.86,
    fill: "#A3A3A3",
    transform: "translate(4.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointMart);
export default __webpack_public_path__ + "static/media/pointMart.ca6e7008ab8b7325d29efe2d27de7dfb.svg";
export { ForwardRef as ReactComponent };